import { setLocalStorage } from "./common";
import { pageURLs } from "../constants/pageURLs";
import { WANT_AD_KEY } from "../constants/common";

// Open the feed's Match tab for a given inventory property. The feed
// (LeftpanelTabContentRight) hydrates the selected property from
// selectedPropertyId by matching Inv_Id, and switches to the Match tab from
// FilterTabKey. Used by the inventory "Matches" pill and the inventory-details
// Matches tab so matches always render on the feed, never inline.
export const goToFeedMatchTab = (navigate, invId) => {
  setLocalStorage("FilterTabKey", "match");
  setLocalStorage("selectedPropertyId", { Inv_Id: invId });
  navigate(pageURLs?.home || "/home");
};

// Synthetic Inv_Id so the Inv_Id-keyed feed selector can hold an MLS listing
// (which has only a ListingKey) without changes.
export const mlsPropertyId = (listingKey) => `mls:${listingKey}`;

export const goToFeedMatchTabForMls = (navigate, listingKey) => {
  setLocalStorage("FilterTabKey", "match");
  setLocalStorage("selectedPropertyId", {
    Inv_Id: mlsPropertyId(listingKey),
    ListingKey: listingKey,
    rowType: "mls",
  });
  navigate(pageURLs?.home || "/home");
};

// Open the want-ad details page's Matches tab.
const goToWantAdMatches = (navigate, wantAdId, slug) => {
  setLocalStorage(WANT_AD_KEY, { wantAdId, introId: 1 });
  navigate(`${pageURLs.wantAdDetails}/${slug}?tabKey=Matches`);
};

// Click handler for the want-listing "Perfect Fit Matches" pill, which sits
// inside a row that also navigates on click. The pill must bail out (without
// touching the event) when there are no matches, so the row's own click
// handler is left free to run - only stop propagation once we're actually
// about to navigate to the Matches tab ourselves.
export const createWantAdMatchClickHandler = (navigate, { wantAdId, slug, hasMatches }) => (e) => {
  if (!hasMatches) return;
  e.stopPropagation();
  goToWantAdMatches(navigate, wantAdId, slug);
};
